import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { DevtoolIndexService } from './DevtoolIndexService';
import { AbstractComponent } from '../../../../core/common/component/AbstractComponent';


import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-devtool',
  templateUrl: './DevtoolIndex.html',
  styleUrls: ['./DevtoolIndex.scss'],
})
export class DevtoolIndexComponent extends AbstractComponent {
  public scope: any = {
    wait: false,
    url : '',
    port : 0
  };

  /**  */
  constructor(
    private title: Title,
    private dialog: MatDialog,
    private service: DevtoolIndexService
  ) {
    super();
    title.setTitle('Dev Tool');
  }

  public componentWillMount() {
    window.scrollTo(0, 0);
  }
  /**  */
  public render() {
  }
  public submit() {
    this.service.create(this.scope.url).subscribe((res:any) => {
      let port = res.spec.ports.find(e => e.name == "web" );
      this.scope.port = port.nodePort
    })
  }
}

/// https://www.youtube.com/watch?v=OYts0uBwI2U